import { buildUserPreferenceRegistry } from '@/business-logic/user-preferences/userPreferenceDiscovery'

export const USER_PREFERENCE_REGISTRY = buildUserPreferenceRegistry(require.context('./settings', true, /^\.\/[^/]+(?:\/index)?\.js$/))
